const RecaptchaActions = {
  signUpWorkspaceAdmin: 'signUpWorkspaceAdmin',
  signUpUser: 'signUpUser',
  signIn: 'signIn',
  acceptInviteByToken: 'acceptInviteByToken',
};

export { RecaptchaActions };
